import { Buffer } from "buffer";
import process from "process";

// Assign globals
window.Buffer = Buffer;
window.process = process;